import ReportsPageContainer from './reports-page-container'

export default ReportsPageContainer
